<template>
    <Chart type="donut" :chartdata="data" :options="options"></Chart>
</template>
<script>
import db from '@/components/firebase.init';
import Chart from '@/components/charts/Charts';
export default {
    data(){
        return{
            
            options: {
                         tooltips: {
    callbacks: {
      label: function(tooltipItem, data) {
        var dataset = data.datasets[tooltipItem.datasetIndex];
        var meta = dataset._meta[Object.keys(dataset._meta)[0]];
        var total = meta.total;
        var currentValue = dataset.data[tooltipItem.index];
        var percentage = parseFloat((currentValue/total*100).toFixed(1));
        return currentValue + ' (' + percentage + '%)';
      },
      title: function(tooltipItem, data) {
        return data.labels[tooltipItem[0].index];
      }
    }
  },
                scales: {
                    yAxes: [{
                        display: true,
                            gridLines: {
                                display: true,
                                color: 'rgb(255, 255, 255, .3)',
                                borderDash: [1],
                                lineWidth: '1',
                                zeroLineWidth: '1',
                                zeroLineColor: 'rgb(255, 255, 255, .3)',
                                },
                        ticks: {
                            beginAtZero: true,
                            fontColor: 'white',
                        }
            
                    }],
                    xAxes: [{
                        display: true,
                            gridLines: {
                                display: true,
                                color: 'rgb(255, 255, 255, .3)',
                                borderDash: [1],
                                lineWidth: '1',
                                zeroLineWidth: '1',
                                zeroLineColor: 'rgb(255, 255, 255, .3)',
                                },
                        ticks: {
                            beginAtZero: true,
                            fontColor: 'white',
                        }
            
                    }],
                },
                animation: {
                easing: 'easeOutBounce',
                numSteps: '100',
                },
                hover: {
                    animationDuration: '1',
                },
                legend: {
                    display: true,
                    labels: {
                    fontColor: 'white',
                    position: 'bottom',
                    }
                },
            },
            data: {},
            chartArray: [0,0,0]
        }
    },
    methods:{
        getChartData(){
            var docRef = db.collection("overallAnalytics").doc("widgetSix");
            docRef.get()
            .then((doc) => {
                const data = doc.data();
                if(data.MALE != null){
                    this.chartArray[0] = data.MALE;
                }
                if(data.FEMALE != null){
                    this.chartArray[1] = data.FEMALE;
                }
            
                this.loadChart();
            })
            .catch(function(error) {
                console.log("Error getting document:", error);
            });
        },
        loadChart(){
            this.data = {
                labels: ['Male', 'Female'],
                datasets: [{
                    data: this.chartArray,
                    backgroundColor: [
                        '#00b4eb', //male
                        '#f67280',
                        '#9f9f9f',
                        
                    ],
                    borderColor: 
                        'rgb(255, 255, 255,1)',
                        
                    
                    borderWidth: 2,
                }]
                }
        }
    },
    components:{
        Chart
    },
    beforeMount(){
        this.getChartData() 
    },
    
}
</script>

